/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_TitleInputs */

const cs_portals_title = /** @type {(inputs: Portals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály`)
};

const en_portals_title = /** @type {(inputs: Portals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portals`)
};

/**
* | output |
* | --- |
* | "Portals" |
*
* @param {Portals_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_title = /** @type {((inputs?: Portals_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_title(inputs)
	return cs_portals_title(inputs)
});